import { useAuthStore } from '@/store/authStore'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Shield, BookOpen, DollarSign, CheckSquare, AlertCircle } from 'lucide-react'

export function MSSP() {
  const { partner } = useAuthStore()
  
  // Only MSSP partners should see this page
  if (partner?.type !== 'MSSP Partner') {
    return (
      <div className="flex h-[50vh] flex-col items-center justify-center">
        <AlertCircle className="h-12 w-12 text-muted-foreground" />
        <h2 className="mt-4 text-xl font-semibold">Access Denied</h2>
        <p className="mt-2 text-muted-foreground">
          This section is only available to MSSP partners.
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <div className="flex items-center gap-2">
          <h1 className="text-2xl font-bold">MSSP Resources</h1>
          <Badge className="bg-purple-500">MSSP Only</Badge>
        </div>
        <p className="text-muted-foreground">
          Managed Security Service Provider specific resources and guides
        </p>
      </div>

      {/* Resource Cards */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader>
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-purple-500/10">
              <BookOpen className="h-6 w-6 text-purple-500" />
            </div>
            <CardTitle>SOC Playbooks</CardTitle>
            <CardDescription>
              Security Operations Center procedures and runbooks
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Comprehensive guides for threat detection, incident response, and security monitoring.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-purple-500/10">
              <Shield className="h-6 w-6 text-purple-500" />
            </div>
            <CardTitle>Multi-Tenant Management</CardTitle>
            <CardDescription>
              Managing multiple customer tenants
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Best practices for managing security policies across multiple customer accounts.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-purple-500/10">
              <DollarSign className="h-6 w-6 text-purple-500" />
            </div>
            <CardTitle>Pricing & Packaging</CardTitle>
            <CardDescription>
              MSSP pricing models and bundling strategies
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Guidance on structuring MSSP service offerings and pricing for customers.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-purple-500/10">
              <CheckSquare className="h-6 w-6 text-purple-500" />
            </div>
            <CardTitle>Onboarding Checklists</CardTitle>
            <CardDescription>
              Customer onboarding procedures
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Step-by-step checklists for bringing new customers onto your MSSP platform.
            </p>
          </CardContent>
        </Card>
      </div>

      {/* Coming Soon */}
      <Card className="border-dashed">
        <CardContent className="flex flex-col items-center justify-center p-12 text-center">
          <Shield className="h-12 w-12 text-muted-foreground" />
          <h3 className="mt-4 text-lg font-medium">More MSSP Resources Coming Soon</h3>
          <p className="mt-2 text-sm text-muted-foreground max-w-md">
            We're working on additional MSSP-specific content including threat intelligence feeds, 
            custom rule libraries, and integration guides.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
